import { useWindowDimensions } from '@app/hooks';
import React, { useContext } from 'react';
import { View } from '@/styles/reactnative';
import { ThemeContext } from '@/theme/ThemeProvider';
import styled from 'styled-components';
import { MobileCalVW } from '@utils/CalVW.tsx';
import { media } from '@/styles/Qtheme.ts';

interface IProps {
  children?: any;
  style?: any;
}
const ProfileSettingBox = ({ children, style }: IProps) => {
  const { width } = useWindowDimensions();
  const { drawerBgColor } = useContext(ThemeContext).theme.COLORS;
  // const wSize = width < 1200 ? '48%' : width < 900 ? '90%' : '32%'
  // const wSize =
  //   width < 600 ? "100%" : width < 1200 ? "100%" : width < 1400 ? "48%" : "32%";
  return <Container wSize={'100%'}>{children}</Container>;
};

export default ProfileSettingBox;

const Container = styled.div<{ wSize?: any }>`
  width: ${({ wSize }) => wSize};
  //height: 400px;
  background: ${({ theme }) => theme.COLORS.BoxBg};
  margin-right: 5px;
  margin-bottom: 5px;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 6px;
  padding: 0 20px;

  @media ${media.mobile} {
    height: auto;
    padding: 20px;
    margin-bottom: 10px;
  }
`;
